import { ICreateNewsForm } from '../../console';

export enum UserRoleEnum {
  ANONYMOUS = 'ANONYMOUS',
  GUEST = 'GUEST',
  PHONE_VERIFIED = 'PHONE_VERIFIED',
  EMAIL_VERIFIED = 'EMAIL_VERIFIED',
  VERIFICATION_PENDING = 'VERIFICATION_PENDING',
  CHAT_MODERATOR = 'CHAT_MODERATOR',
  VERIFIED = 'VERIFIED',
  ADMIN = 'ADMIN',
  DEACTIVATED = 'DEACTIVATED',
  SUSPENDED = 'SUSPENDED',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

export interface IUserData {
  email?: string;
  roles?: UserRoleEnum[];
  userId?: string;
  balance?: number;
  lockedBalance?: number;
  login: string;
  createdAt?: string;
  key: string;
  imageUrl?: string;
  transactionsPanding?: ITransactionPandingItem[];
}

export interface ITransactionPandingItem {
  amount: string;
  transactionId: string;
  createdAt: string;
  balanceWitdrawal: IBalanceWitdrawal;
}

export interface IBalanceWitdrawal {
  currency: string;
  wallet: string;
}

export enum TransactionTypeEnum {
  GAME_TRANSFER = 'GAME_TRANSFER',
  TRANSFER = 'TRANSFER',
  DEPOSIT = 'DEPOSIT',
  WITHDRAWAL = 'WITHDRAWAL',
  FEE = 'FEE',
}

export enum TransactionStatusEnum {
  CREATED = 'CREATED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
}

export interface ITransferItem {
  transactionId: string;
  type: TransactionTypeEnum;
  status: TransactionStatusEnum;
  updatedAt?: string;
  createdAt?: string;
  amount: string;
}

export enum MessageTypeEnum {
  PERSONAL = 'PERSONAL',
  CHAT = 'CHAT',
}

export interface IMessageItem {
  createdAt: string;
  message: string;
  messageId: string;
  type: MessageTypeEnum;
  userId: string;
  userName: string;
  recipientId?: string;
  recipientName?: string;
}

export interface INewsItem extends ICreateNewsForm {
  newsId: string;
  createdAt: string;
}

export interface IReferralItem {
  login: string;
  games: number;
  winner: number;
  profit: string;
}

export interface IRemoveBalanceForm {
  amount: number;
  wallet: string;
  currency: string;
}
